// layouts/auth/ImpersonationBar.jsx
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Icon from "@mui/material/Icon";
import Typography from "@mui/material/Typography";
import { useAuth } from "./AuthContext";
import { useSoftUIController } from "context";

const SIDENAV_WIDTH_FULL = 250;
const SIDENAV_WIDTH_MINI = 96;

export default function ImpersonationBar() {
  const { isImpersonating, stopImpersonating, user } = useAuth(); // 👈 nombre correcto
  const [controller] = useSoftUIController();
  const miniSidenav = controller?.miniSidenav ?? false;

  if (!isImpersonating) return null;

  const leftBasePx = miniSidenav ? SIDENAV_WIDTH_MINI : SIDENAV_WIDTH_FULL;

  const handleBack = async () => {
    try {
      await stopImpersonating();
    } catch (e) {
      console.error("[ImpersonationBar] stopImpersonating error:", e);
    }
  };

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: { xs: "calc(12px + env(safe-area-inset-bottom, 0px))", lg: 16 },
        left: { xs: 12, lg: leftBasePx + 16 },
        right: 16,
        zIndex: (t) => (t?.zIndex?.modal ?? 1300) + 10,
        display: "flex",
        justifyContent: "center",   // centrado
        pointerEvents: "none",
      }}
    >
      <Paper
        elevation={3}
        sx={{
          px: 1.5,
          py: 1,
          borderRadius: 999,
          display: "flex",
          alignItems: "center",
          gap: 1.25,
          backdropFilter: "blur(6px)",
          bgcolor: (t) =>
            t.palette.mode === "dark" ? "rgba(18,18,18,0.6)" : "rgba(255,255,255,0.65)",
          border: (t) => `1px solid ${t.palette.divider}`,
          pointerEvents: "auto",
        }}
      >
        <Typography variant="caption" sx={{ opacity: 0.85 }}>
          Navegando como{" "}
          <strong>{user?.username || user?.email || `usuario #${user?.id ?? ""}`}</strong>
        </Typography>

        <Button
          size="small"
          color="info"
          variant="contained"
          onClick={handleBack}
          startIcon={<Icon>person_off</Icon>}
          sx={{ borderRadius: 999, textTransform: "none" }}
        >
          Volver a admin
        </Button>
      </Paper>
    </Box>
  );
}
